import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const HomeOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 4.99a1.49 1.49 0 0 0-.99-.39l-.01.02c-.37 0-.71.13-1 .39l-5.81 5.23c-.37.34-.59.84-.59 1.38v6.01c0 .49.18.95.5 1.29.29.32.68.49 1.09.49h11.62c.88 0 1.59-.8 1.59-1.78v-6.05c0-.54-.22-1.05-.6-1.39L13 4.99ZM9.93 3.82c.6-.53 1.33-.8 2.07-.8l.01-.02c.73 0 1.47.27 2.06.8l5.8 5.2c.72.64 1.13 1.59 1.13 2.58v6.05c0 1.87-1.43 3.38-3.19 3.38H6.19C4.43 21.01 3 19.5 3 17.63v-6.01c0-.99.41-1.93 1.12-2.57l5.81-5.23ZM8.69 16.2a.8.8 0 1 0 0 1.6h6.62a.8.8 0 0 0 0-1.6H8.69Z"
      fill={color}
    />
  </Svg>
)

export default HomeOutlined
